module.exports = __webpack_public_path__ + "media/images/chek-white-49e6fd0f298daeb5664363ba79140c01.png";